/**
 * Runs non-critical work well after the page is interactive: on the first user
 * interaction, or after a generous delay once the page has loaded. Keeps
 * analytics/toast bootstrapping off the main thread during the critical window.
 */
export const deferIdle = (fn: () => void, delayMs = 4000) => {
  if (typeof window === "undefined") return;
  let done = false;
  const w = window as Window & {
    requestIdleCallback?: (cb: () => void, o?: { timeout: number }) => void;
  };
  const events = ["pointerdown", "keydown", "touchstart", "scroll"] as const;

  const run = () => {
    if (done) return;
    done = true;
    events.forEach((e) => window.removeEventListener(e, run));
    if (w.requestIdleCallback) w.requestIdleCallback(fn, { timeout: 2000 });
    else fn();
  };

  events.forEach((e) =>
    window.addEventListener(e, run, { once: true, passive: true }),
  );

  const schedule = () => window.setTimeout(run, delayMs);
  if (document.readyState === "complete") schedule();
  else window.addEventListener("load", schedule, { once: true });
};
